/*
 * @Author: cc
 * @Date: 2020-12-30 10:19:29
 * @LastEditTime: 2022-01-20 15:56:52
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\kuaishou\draft\draft.js
 * @Description: 快手新建稿件页面
 */
'use strict';
angular.module('editKuaishouDraftModule', []).controller('EditKuaishouDraftCtrl', [
    '$scope',
    '$state',
    '$controller',
    '$element',
    'editingCenterKuaishouservice',
    'KuaishouConst',
    function (
        $scope,
        $state,
        $controller,
        $element,
        editingCenterKuaishouservice,
        KuaishouConst
    ) {
        initStatus();
        initArrayBtn();

        /**
         * [initStatus description]初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            // 视频上传限制
            $scope.videolimit = {
                name: '快手',
                size: 300,
                duration: 15,
                accept: {
                    title: '视频',
                    extensions: 'mp4',
                    mimeTypes: 'video/mp4',
                },
            };
            $scope.trenchStatus = {
                meteDataId: $state.params.articleid, // 稿件ID
                // serviceidKey: 'mlf_kuaishou', // serviceid
                articleIdKey: 'METADATAID', // 文章ID的KEY
                // isEditDraft: !!$state.params.articleid,
            };
            
            $scope.trenchData = {
                trenchConst: KuaishouConst,
            };
            $scope.trenchList = {
                serviceid: 'mlf_kuaishou',
                METADATAID: $state.params.articleid || 0,
                accountId: $state.params.accountid
            }; // 渠道下list对象的特殊值
            $scope.trenchDraftParams = {
                serviceid: 'mlf_kuaishou',
                methodName: 'findMetaDataById',
                MetaDataId: $state.params.articleid,
            }; // 渠道下获取稿件信息的参数
            $scope.operateParams = { // 送审、签发、撤稿
                docids: $state.params.articleid,
                accountId: $state.params.accountid,
            }; // 渠道下的操作参数
            $controller('EditShortVideoNewDraftCtrl', {$scope: $scope, $element: $element}); // 控制器继承
        }

       
        /**
         * [refreshParams description] 刷新参数
         * @param   {[object]}  data  [data description] 保存后返回的数据
         * @return  {[type]}          [return description]
         */
        $scope.refreshParams = function(data){
            if (data){
                $state.params.articleid = data.METADATAID.replace(/\"/g, '');
            }
            $scope.operateParams = { // 送审、签发、撤稿
                docids: $state.params.articleid,
                accountId: $state.params.accountid,
            };
        };

        /**
         * [initArrayBtn description]初始化按钮
         * @return {[type]} [description]
         */
        function initArrayBtn() {
            if (!$scope.status.isFusionEditor) {
                editingCenterKuaishouservice.initKuaishouEditerBtn($state.params.platform, $state.params.accountid).then(function(data) {
                    $scope.arrayBtn = data;
                });
            }
        }
        
    },
]);
